export default [
  {
    path: "/emergency",
    name: "emergency",
    component: () => import("@/views/emergency/MainEmergency.vue"),
  },
  {
    path: "/patient-emergency-info/:id",
    name: "patient-emergency-info",
    component: () => import("@/views/emergency/PatientEmergencyInfo.vue"),
  },
  {
    path: "/patient-drug-table",
    name: "patient-drug-table",
    component: () => import("@/views/emergency/PatientDrugTable.vue"),
  },
  {
    path: "/patient-drug-table/:id",
    name: "patient-drug-table-id",
    component: () => import("@/views/emergency/DrugTable.vue"),
  },
  {
    path: "/testsss",
    name: "testsss",
    component: () => import("@/components/printables/ShoAndNursing.vue"),
  },
];
